import { ButtonsSection, FGCustomPanel, FGTextInput, showError, showSuccess, StyledCard } from "nsitools-react";
import * as React from "react";
import { useHistory } from "react-router";
import * as Yup from "yup";

import { AuthenticateCommand, EPlatform, UsersApi } from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { isBrcs } from "../../../DrupalApp";

export interface IDrupalForgottenPasswordPageProps {}

export const DrupalForgottenPasswordPage: React.FunctionComponent<IDrupalForgottenPasswordPageProps> = () => {
  const { t } = useTl();
  const history = useHistory();
  const api = useApiService(UsersApi);
  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      email: Yup.string().email(t(ETLCodes.InvalidEmail)).nullable().required(t(ETLCodes.Required)),
    });
  }, [t]);
  const [loading, setloading] = React.useState(false);
  const resetPassword = React.useCallback(
    async (values: any) => {
      setloading(true);
      try {
        const res = await api.resetPassword(values.email, EPlatform.PORTAL, isBrcs);
        if (res !== null && res.value) {
          showSuccess(t(ETLCodes.NewPasswordEmailSent));
          history.push(EDrupalRoutes.login);
        } else {
          showError(t(ETLCodes.UnknownEmail));
        }
        setloading(false);
        return res;
      } catch {
        setloading(false);
        showError(t(ETLCodes.Error));
      }
    },
    [api, history, t]
  );

  return (
    <PageContainer isCentered={true}>
      <h1>{t(ETLCodes.ForgottenPasswordTitle)}</h1>
      <StyledCard elevation={2}>
        {/* <h2>{t(ETLCodes.For)}</h2> */}
        <DrupalFormGenerator
          initialValues={AuthenticateCommand.fromJS({
            email: "",
          })}
          onSubmit={resetPassword}
          labelAlignment="right"
          fill={true}
          inline={true}
          boldLabel={false}
          validationSchema={validationSchema}
          hideButtons={true}
          autoRequiredMark={true}
          showColons={false}
          enableDirtyCheck={false}
          large={true}
        >
          <FGTextInput name="email" label={t(ETLCodes.MailAddress)} />

          <FGCustomPanel>
            {() => (
              <ButtonsSection
                buttons={[
                  {
                    outlined: true,
                    minimal: true,
                    position: "center",
                    text: t(ETLCodes.DrupalLoginButton),
                    intent: "primary",
                    type: "submit",
                    large: true,
                    loading: loading,
                  },
                ]}
              />
            )}
          </FGCustomPanel>
        </DrupalFormGenerator>
      </StyledCard>
    </PageContainer>
  );
};
